import { VoltageTypes } from '../enums/voltage-types.enum';
import { AssetStatus, AssetStatusEnum } from './assetStatus.model';
import { DTFencingStatus, DTStatus } from './dt.model';
import { FeederType } from './feeder.model';
import { Image } from './image.model';

export interface RmuEdit {
  //RMU INFORMATION
  voltageType: VoltageTypes;
  voltageLevel: VoltageTypes;
  dtStatus: DTStatus;
  slrn: string;
  assetStatus: AssetStatusEnum;
  fencedStatus: DTFencingStatus;
  manufacturerName: string;
  serialNumber: string;
  numberOfOutput: number;
  type: string;
  manufactureDate: Date | null;
  commissioningDate: Date | null;
  locationAddress: string;
  locationLandmark: string;
  latitude: number;
  longitude: number;
  //Network Information
  transmissionStation: string;
  feeder33Name: string;
  substationName: string;
  feeder11Name: string;
  region: string;
  district: string;

  //User Activity
  firstCapturedUser: string;
  lastCapturedUser: string;
  creationDate: string;
  updatedDate: string;
  reassignedBy: string;
  assignedUser: string;
  validatedBy: string;
  validatedDate: string;
  auditedStatus: string;
  auditedBy: string;
  auditedDate: string;
  valdiationStatus: string;
  comment: string;
  //Connected
  connectedDts: number;
  connectedBuildings: number;
  customerPopulation: number;

  //Images
  images: Image[];


  //Miscalenious
  dataQualityId :number;
  areaId : number;
  assignedUserId:number;
  guid:string;
}
export function getInitRmuEdit(): RmuEdit {
  return {
    voltageType: VoltageTypes.KV11,
    voltageLevel: VoltageTypes.KV11,
  dtStatus: DTStatus.Active,
  assetStatus:AssetStatusEnum.Assigned,
  fencedStatus: DTFencingStatus.Compact,
  manufacturerName: '',
  serialNumber: '',
  numberOfOutput: 0,
  type: '',
  slrn :'',
  manufactureDate: new Date(),
  commissioningDate: new Date(),
  locationAddress: '',
  locationLandmark: '',
  latitude: 0,
  longitude: 0,
  //Network Informatio
  transmissionStation: '',
  feeder33Name: '',
  substationName: '',
  feeder11Name: '',
  region: '',
  district: '',
  //User Activit
  firstCapturedUser: '',
  lastCapturedUser: '',
  creationDate: '',
  updatedDate: '',
  reassignedBy: '',
  assignedUser: '',
  validatedBy: '',
  validatedDate: '',
  auditedStatus: '',
  auditedBy: '',
  auditedDate: '',
  valdiationStatus: '',
  comment: '',
  //Connecte
  connectedDts: 0,
  connectedBuildings: 0,
  customerPopulation: 0,
  //Image
  images: [],

  //Miscalenious 
  dataQualityId : 0,
  areaId : 0,
  assignedUserId: 0,
  guid : ''
  }

}

export class RmuDtoCreate {
  id: number;
  voltageLevel: string; 
  status: string;
  fencedStatus: string;
  manufacturerName: string;
  serialNumber: string;
  numberOfOutput: number;
  type: string;
  manufactureDate: string | null; 
  commissioningDate: string | null;
  locationAddress: string;
  locationLandmark: string;
}

export class RmuList {
  id: number;
  slrn: string;
  type: string;
  voltageLevel: VoltageTypes;
  status: DTStatus;
  assetStatus: string;
  feederVoltage: FeederType;
  feederName: string;
  locationAddress: string;
  area: string;
  region: string;
  validationStatus: string;
  checked: boolean = false;
}

export class RmuStats {
  count: number;
  statType: RmuStatsOptions;
}
export enum RmuStatsOptions {
  Total,
  Retagged,
  NumberOfDts,
  NumberOfFeeders,
  NumberOfFeeders33,
  NumberOfFeeders11
}